module.exports = __webpack_public_path__ + "img/maatafa_yes.3d80c9bd.png";